export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_bank_name') || '开户银行',
    field: 'bankName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_bank_account_name') || '账户名称',
    field: 'bankAccountName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_bank_account_no') || '银行账号',
    field: 'bankAccountNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_bank_account_type') || '账户性质',
    field: 'v_bankAccountType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 60,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_bank_account_kind') || '账号类别',
    field: 'v_bankAccountKind',
    headerAlign: 'center',
    align: 'center',
    minWidth: 60,
    showHeaderOverflow: true,
    showOverflow: true
  },


]
